import { render, staticRenderFns } from "./administratorRechargeReview.vue?vue&type=template&id=1fa6756b&"
import script from "./administratorRechargeReview.vue?vue&type=script&lang=js&"
export * from "./administratorRechargeReview.vue?vue&type=script&lang=js&"
import style0 from "./administratorRechargeReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports